import { OnboardingDetailsRole, Product } from '@nemuru-eng/js-api-client';

import { Text } from '@/components/shared/components/Text';
import { GetLoanDetailActionsByRoleProps } from '@/components/widgets/LoanDetailActions/types/GetLoanDetailActionsByRoleProps';
import { LoanDetailAction } from '@/components/widgets/LoanDetailActions/types/LoanDetailAction';
import { APP_ROLES } from '@/config/config';

export const getLoanApplicationRelatedActions = ({
  toggleActionDialog,
  loan,
  role,
}: GetLoanDetailActionsByRoleProps) => {
  const allowedRoles = [APP_ROLES.SUPER_ADMIN, APP_ROLES.ADMIN, APP_ROLES.CPC_BACK_OFFICE];

  const loanHasParticipants = loan.onboardingDetails.some((detail) => detail.role !== OnboardingDetailsRole.BORROWER);

  if (!allowedRoles.includes(role)) return [];

  return [
    {
      display: <Text tId={'CHANGE_LOAN_CONDITIONS'} />,
      onClick: () => toggleActionDialog(LoanDetailAction.CHANGE_LOAN_CONDITIONS),
      iconName: 'price_change',
      disabled:
        loan.loanApplicationSelected?.lenderFields.lenderRequestId ||
        loan.loanConditions.product === Product.CREDIT_LINE,
    },
    {
      display: <Text tId={'UPDATE_LOAN_APPLICATION_IN_LENDER'} />,
      onClick: () => toggleActionDialog(LoanDetailAction.UPDATE_LOAN_APPLICATION_IN_LENDER),
      iconName: 'cloud_sync',
      disabled: !loan.loanApplicationSelected?.lenderFields.lenderRequestId || !loanHasParticipants,
    },
  ];
};
